























import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import {ISnackBarState, SNACK_ACTION} from '@/_store/snackbar';
import {store} from '@/_store';
import {ACCOUNT_ACTION} from "@/_store/account";
import {getTokenDateFromCookie} from "@/_helpers/http";

@Component({
  computed: mapState('snackbar', {
    snackbar: (state: ISnackBarState) => state,
  }),
})
export default class App extends Vue {
  public snackbar!: ISnackBarState;
  private closeSnackbar() {
    store.dispatch(SNACK_ACTION.CLEAR);
  }

  private mounted() {
    this.stillLoggedInSetup();
    this.idleSetup();
  }

  private stillLoggedInSetup() {
    // Check every minute if we are still logged in
    const stillLoggedInIntervalHandler = window.setInterval(() => {
      if (store.getters[ACCOUNT_ACTION.IS_AUTHENTICATED]) {
        store.dispatch(ACCOUNT_ACTION.SELF);

        // Refresh token every 45 minutes if active to be safe.
        const date = new Date(getTokenDateFromCookie());
        const diffInMinutes = ((new Date()).getTime() - date.getTime()) / 1000 / 60;
        if (diffInMinutes >= 45) {
          store.dispatch(ACCOUNT_ACTION.REFRESH_TOKEN);
        }
      }
    }, 60000);
  }

  private idleSetup() {
    let idleHandler: number;

    function resetTimer() {
      window.clearTimeout(idleHandler);
      startTimer();
    }

    function startTimer() {
      idleHandler = window.setTimeout(() => {
        if (store.getters[ACCOUNT_ACTION.IS_AUTHENTICATED]) {
          store.dispatch(ACCOUNT_ACTION.LOGOFF);
        }
        startTimer();
      }, 1000 * 60 * 30); // 30 minute inactivity timeout
    }

    addEventListener("mousemove", resetTimer, false);
    addEventListener("mousedown", resetTimer, false);
    addEventListener("keypress", resetTimer, false);
    addEventListener("DOMMouseScroll", resetTimer, false);
    addEventListener("mousewheel", resetTimer, false);
    addEventListener("touchmove", resetTimer, false);
    addEventListener("MSPointerMove", resetTimer, false);

    startTimer();
  }
}
